class ProductMain extends ProductInfo {
    constructor() {
        super();
        const isMobile = window.matchMedia("(max-width: 768px)").matches;
        if(!isMobile) this.setScrollHandle();
        this.initDetailDialog();
    }

    setScrollHandle(){
        let fixedBox = this.querySelector('.product-main-fixed');
        let scrollBox = fixedBox.querySelector('.product-main-scroll');
        let scrollLength = scrollBox.offsetHeight - fixedBox.offsetHeight;
        if(scrollLength > 0){
            scrollLength += 200;
            let parentDom = this.parentElement;
            parentDom.style.height = `${this.offsetHeight + scrollLength * 2}px`;
            let header = document.querySelector('.section-header');
            ScrollTrigger.create({
                id: 'product-main',
                trigger: parentDom,
                start: () => "top top",
                end: () => "bottom bottom",
                scrub: 1,
                markers: false,
                animation: gsap.fromTo(scrollBox, {y: 0}, {y: -scrollLength}),
                onUpdate: self => {
                    header.style.setProperty("top", "0px", "important");
                },
                onLeave: ({progress, direction, isActive}) => {
                    header.style.removeProperty("top");
                },
                onLeaveBack: ({progress, direction, isActive}) => {
                    header.style.removeProperty("top");
                }
            })
        }
    }
    initDetailDialog(){
        let detailBtn = this.querySelector('.detail-pictures-btn');
        if(!detailBtn) return;
        let detailDialog = this.parentElement.querySelector('.detail-pictures-dialog');
        let detailSwiper = new Swiper (detailDialog.querySelector('.swiper'), {
            spaceBetween: 20,
            slidesPerView: "auto",
            centeredSlides: true,
            grabCursor: true,
            pagination: {
                el: detailDialog.querySelector('.swiper-pagination')
            },
            navigation: {
                nextEl: detailDialog.querySelector('.swiper-button-next'),
                prevEl: detailDialog.querySelector('.swiper-button-prev')
            }
        })
        detailBtn.addEventListener('click', function(){
            detailDialog.classList.add('open');
            document.body.classList.add('overflow-hidden');
        })
        detailDialog.querySelectorAll('.close-btn').forEach((btn) => {
            btn.addEventListener("click", function () {
                detailDialog.classList.remove('open');
                document.body.classList.remove('overflow-hidden');
            });
        })
    }
    updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;
        let activeImg = this.querySelector(`.product-img-list img[data-id="${variantFeaturedMediaId}"]`);
        if(activeImg){
            this.querySelector(".product-img-list img.active").classList.remove("active");
            activeImg.classList.add("active");
        }
    }
    handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;
        document.querySelector(`#${target.id}`)?.focus();

        let oldImgDom = this.querySelector(".product-img-list img.active");
        let title = oldImgDom?.dataset.title.split(" / ");
        title[target.name.split('-')[1] - 1] = target.value;
        title = title.join(" / ");
        let newImgDom = this.querySelector(`.product-img-list img[data-title="${title}"]`);
        oldImgDom.classList.remove("active");
        newImgDom.classList.add("active");
        
        const variant_id = newImgDom.dataset.variant_id;
        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.updateURL(productUrl, variant_id);
        this.updateVariantInputs(variant_id);
        
        const price = newImgDom.dataset.price;
        this.querySelector(`#price-${this.dataset.section} .price__regular .price-item`).innerHTML = price;

        const productForm = this.productForm;
        productForm?.toggleSubmitButton(
            newImgDom.dataset.sold_out == 'ture' ? true : false,
            window.variantStrings.soldOut
        );
        productForm?.handleErrorMessage();
    }
}

if (!customElements.get('product-main')) {
    customElements.define('product-main', ProductMain);
}